/* eslint-disable react-hooks/exhaustive-deps */

import {useEffect, useRef} from "react";

export const useWillUnmount = (fn: void | VoidFunction | undefined): void => {
  const hasSettledRef = useRef(false);

  useEffect(() => {
    // Mark as settled after a tick - StrictMode cleanup happens synchronously
    const timeout = setTimeout(() => {
      hasSettledRef.current = true;
    }, 0);

    return () => {
      clearTimeout(timeout);
      // Only run cleanup if the component had "settled" (not a StrictMode cycle)
      if (hasSettledRef.current) {
        fn && fn();
      }
    };
  }, []);
};
